import type { FilterConditionDTO } from "@/shared/contracts/base";
import { findCondition } from "@/shared/contracts/query-helpers";
import type { RequestCalendarQueryDTO } from "../../domain/contracts/request-calendar";

export const REQUEST_CALENDAR_STATUS_LABELS: Record<string, string> = {
  new: "ໃໝ່",
  negotiating: "ກຳລັງເຈລະຈາ",
  pending_quote: "ລໍຖ້າໃບສະເໜີລາຄາ",
  won: "ຢືນຢັນແລ້ວ",
  lost: "ເສຍໂອກາດ",
  cancelled: "ຍົກເລີກ",
};

export const REQUEST_CALENDAR_STATUS_BADGE: Record<string, string> = {
  new: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  negotiating:
    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  pending_quote:
    "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  won: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  lost: "bg-muted text-muted-foreground",
  cancelled: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
};

export const REQUEST_CHANNEL_LABELS: Record<string, string> = {
  phone: "ໂທລະສັບ",
  line: "Line",
  facebook: "Facebook",
  walk_in: "ເຂົ້າມາຕິດຕໍ່",
  referral: "ແນະນຳ",
  other: "ອື່ນໆ",
};

export function parseRequestCalendarFilters(filters: FilterConditionDTO[] = []) {
  const title = findCondition(filters, "title")?.value;
  const status = findCondition(filters, "status")?.value;
  const channel = findCondition(filters, "channel")?.value;
  const assignedTo = findCondition(filters, "assignedTo")?.value;
  const priorityFilter = findCondition(filters, "priorityOrder");

  return {
    title: typeof title === "string" && title.trim() ? title.trim() : undefined,
    status:
      typeof status === "string" && status.trim() ? status.trim() : undefined,
    channel:
      typeof channel === "string" && channel.trim() ? channel.trim() : undefined,
    assignedTo:
      typeof assignedTo === "string" && assignedTo.trim()
        ? assignedTo.trim()
        : undefined,
    priorityOnly: priorityFilter?.op === "isNotNull",
  };
}

export function buildRequestCalendarQuery(input: {
  start: string;
  end: string;
  filters?: FilterConditionDTO[];
}): RequestCalendarQueryDTO {
  const parsed = parseRequestCalendarFilters(input.filters);
  return {
    start: input.start,
    end: input.end,
    ...(parsed.status ? { status: parsed.status } : {}),
    ...(parsed.title ? { title: parsed.title } : {}),
    ...(parsed.channel ? { channel: parsed.channel } : {}),
    ...(parsed.assignedTo ? { assignedTo: parsed.assignedTo } : {}),
    ...(parsed.priorityOnly ? { priorityOnly: true } : {}),
  };
}
